module.exports = __webpack_public_path__ + "static/media/DancingScript-VariableFont_wght.d3bebba9.ttf";